import { useNavigate } from "react-router-dom";

type QueryParams = Record<string, string | number | boolean | undefined | null>;

function useSaveQueryParams() {
    const navigate = useNavigate();

    return (params: QueryParams) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                searchParams.set(key, String(value));
            }
        });

        navigate(`?${searchParams.toString()}`, { replace: true });
    };
}
export default useSaveQueryParams;
